import config from 'react-global-configuration';

export const getUserStatistics = (id: string): Promise<Response> =>
  fetch(`${config.get('ApiUrl').Rest}/dashboard/userStatistics/${id}`, {
    method: 'GET',
    mode: 'cors',
    credentials: 'include',
  });
